import React from 'react';
import {useHistory} from 'react-router-dom';
import {useDispatch} from 'react-redux';
import Type from '@actionTypes';
import './index.less';
import User from './User';
import Tabs from './tabs';

const Header = (props) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const changePwd = () => {
    history.push('/editPassword');
  }
  const logout = () => {
    dispatch({
      type: Type.USER_LOGOUT,
      cb: () => {
        sessionStorage.clear();
        history.replace('/')
        dispatch({ type: Type.CLEAR_MENU })
      }
    })
  }

  return (
    <div className="header">
      <User changePwd={changePwd} logout={logout} />
      <Tabs props={props} />
    </div>
  );
}

export default Header;
